module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_12-06ab329a732fcb110b978a1fce776551.jpg";